import React from "react";

const InviteTabSwitch = ({ active, onChange }) => {
  const tabs = [
    { key: "manual", label: "Manual entry" },
    { key: "bulk", label: "Bulk upload" },
  ];
  return (
    <div
      style={{
        display: "inline-flex",
        gap: 4,
        padding: 4,
        background: "#e6e9ee",
        borderRadius: 999,
        alignSelf: "flex-start",
      }}
    >
      {tabs.map((t) => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            style={{
              padding: "6px 14px",
              borderRadius: 999,
              border: "none",
              background: isActive ? "var(--surface)" : "transparent",
              color: isActive ? "var(--ink)" : "var(--ink-3)",
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: isActive ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default InviteTabSwitch;
